import pluralize from 'pluralize'
import moment from 'moment'

const Token = (wait) => {
  if(wait.strategy === 'duration') {
    const { duration_days, duration_hours, duration_mins } = wait
    const duration = []
    if(duration_days) duration.push(pluralize('day', parseInt(duration_days), true))
    if(duration_hours) duration.push(pluralize('hour', parseInt(duration_hours), true))
    if(duration_mins) duration.push(pluralize('min', parseInt(duration_mins), true))
    return `for ${duration.join(', ')}`
  } else if(wait.strategy === 'datetime') {
    return `until ${moment(`${wait.until_date} ${wait.until_time}`).format('MM/DD/YY [@] hh:mm A')}`
  } else if(wait.strategy === 'time') {
    const now = moment().format('YYYY-MM-DD')
    return `until ${moment(`${now} ${wait.until_time}`).format('hh:mm A')}`
  }
}

export default Token
